import { render, staticRenderFns } from "./DoublePane.vue?vue&type=template&id=3cf2f33e&scoped=true&"
import script from "./DoublePane.vue?vue&type=script&lang=js&"
export * from "./DoublePane.vue?vue&type=script&lang=js&"
import style0 from "./DoublePane.vue?vue&type=style&index=0&id=3cf2f33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf2f33e",
  null
  
)

export default component.exports